import { render, staticRenderFns } from "./MtcSearch.vue?vue&type=template&id=44756bc0&"
import script from "./MtcSearch.vue?vue&type=script&lang=js&"
export * from "./MtcSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports